<template>
  <div class="modal show fade modal-danger text-left" style="display: block;" v-if="show">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" style="text-transform:capitalize;">{{detailType}}</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="card">
            <div class="card-body"  v-if="detailType == 'all'">
              <div class="d-flex align-items-center pb-3 border-bottom mb-3">
                <div class="mr-auto">
                  <h6 class="fs-16 font-w600 mb-0"><a href="javascript:void(0)" class="text-warning  font-weight-bolder">Amount</a></h6>
                </div>
                <span style="font-size: larger" class=" font-weight-bolder text-dark">{{list.total_amount / 100}}</span>
              </div>
              <div class="d-flex align-items-center pb-3 border-bottom mb-3">
                <div class="mr-auto">
                  <h6 class="fs-16 font-w600 mb-0"><a href="javascript:void(0)" class="text-warning  font-weight-bolder">Fee</a></h6>
                </div>
                <span style="font-size: larger" class=" font-weight-bolder text-dark">{{list.fee / 100}}</span>
              </div>
              <div class="d-flex align-items-center pb-3 border-bottom mb-3">
                <div class="mr-auto">
                  <h6 class="fs-16 font-w600 mb-0"><a href="javascript:void(0)" class="text-warning  font-weight-bolder">Total Amount</a></h6>
                </div>
                <span style="font-size: larger" class=" font-weight-bolder text-dark">{{list.total_amount / 100}}</span>
              </div>
              <div class="d-flex align-items-center pb-3 border-bottom mb-3">
                <div class="mr-auto">
                  <h6 class="fs-16 font-w600 mb-0"><a href="javascript:void(0)" class="text-warning  font-weight-bolder">Method</a></h6>
                </div>
                <span style="font-size: larger" class=" font-weight-bolder text-dark">{{(list.payment_method)  ? list.payment_method.name  : ''}}</span>
              </div>
              <div class="d-flex align-items-center pb-3 border-bottom mb-3">
                <div class="mr-auto">
                  <h6 class="fs-16 font-w600 mb-0"><a href="javascript:void(0)" class="text-warning  font-weight-bolder">Receiver Account Num</a></h6>
                </div>
                <span style="font-size: larger" class=" font-weight-bolder text-dark">{{list.receiver_account_number}}</span>
              </div>
              <div class="d-flex align-items-center pb-3 border-bottom mb-3">
                <div class="mr-auto">
                  <h6 class="fs-16 font-w600 mb-0"><a href="javascript:void(0)" class="text-warning  font-weight-bolder">Receiver Account Title</a></h6>
                </div>
                <span style="font-size: larger" class=" font-weight-bolder text-dark">{{list.receiver_account_title}}</span>
              </div>
              <div class="d-flex align-items-center pb-3 border-bottom mb-3">
                <div class="mr-auto">
                  <h6 class="fs-16 font-w600 mb-0"><a href="javascript:void(0)" class="text-warning  font-weight-bolder">Sender Account Num</a></h6>
                </div>
                <span style="font-size: larger" class=" font-weight-bolder text-dark">{{list.sender_account_number}}</span>
              </div>
              <div class="d-flex align-items-center pb-3 border-bottom mb-3">
                <div class="mr-auto">
                  <h6 class="fs-16 font-w600 mb-0"><a href="javascript:void(0)" class="text-warning  font-weight-bolder">Sender Account Title</a></h6>
                </div>
                <span style="font-size: larger" class=" font-weight-bolder text-dark">{{list.sender_account_title}}</span>
              </div>
              <div class="d-flex align-items-center pb-3 border-bottom mb-3">
                <div class="mr-auto">
                  <h6 class="fs-16 font-w600 mb-0"><a href="javascript:void(0)" class="text-warning  font-weight-bolder">UUID</a></h6>
                </div>
                <span style="font-size: larger" class=" font-weight-bolder text-dark">{{list.uuid}}</span>
              </div>
              <div class="d-flex align-items-center pb-3 border-bottom mb-3">
                <div class="mr-auto">
                  <h6 class="fs-16 font-w600 mb-0"><a href="javascript:void(0)" class="text-warning  font-weight-bolder">Vat</a></h6>
                </div>
                <span style="font-size: larger" class=" font-weight-bolder text-dark">{{list.vat}}</span>
              </div>
            </div>
            <div class="card-body table-responsive p-0 table-striped table-hover table-bordered" v-if="detailType == 'charges'">
              <table class="table table-head-fixed table-hover-animation text-nowrap">
                <thead>
                <tr>
                  <th>S.NO</th>
                  <th>Name</th>
                  <th>Type</th>
                  <th>Charges</th>
                </tr>
                </thead>
                <tbody>
                <tr :key="index" v-for="(row, index) in list" >
                  <td>{{index +1}}</td>
                  <td>{{row.name}}</td>
                  <td>{{row.type}}</td>
                  <td>{{row.charges}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-danger" data-dismiss="modal" @click="$emit('hide')">Close</button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="show" class="modal-backdrop fade show"></div>
</template>

<script>

export default {
  props: ['show', 'data', 'index','detailType'],
  data() {
    return {
      list: [],
      // showModal: false,
    }
  },
  mounted() {
    // this.list = this.data
  },
  methods: {
    setupData() {
    }
  },
  watch: {
    show() {
      this.list = this.data
    },
    detailType() {

    }
  }
}
</script>

<style scoped>
.modal-dialog{
  overflow-y: initial !important
}
.modal-body{
  height: 70vh;
  overflow-y: auto;
}
</style>

